<template>
  <div>
    <div class="card p-3 shadow-sm">
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col d-flex align-items-center flex-wrap">
          <h5 class="e-text-red mb-0 mr-2">
            Rightship Inspection Ship Questionnaire (RISQ) - Findings
          </h5>
          <select
            class="form-control form-control-sm w-auto"
            v-model="selectedRevisionId"
            @change="onRevisionChange"
            :style="{
    fontWeight: 'bold',
  }"
          >
            <option
              v-for="rev in revisions"
              :key="rev.id"
              :value="rev.id"
              :disabled="rev.id === selectedRevisionId"
            >
              v{{ rev.revision_number }}
            </option>
          </select>

        </div>
        <div class="col-auto">
          <button
            class="e-btn e-btn-green px-4 e-text-white"
            data-target="#nonConformityNew"
            data-toggle="modal"
            v-if="isAllowed('rightship.main.risq-findings.index.create') || user.id === rsReport.created_by_id || isElite() || isOwnVessel('rsReport')"
          >
            <font-awesome-icon icon="plus" class="mr-2" />
            Add Findings
          </button>
        </div>
      </div>

      <div class="row no-gutters justify-content-between mb-1">
        <div class="col-sm-auto pb-2 mr-2">
          <nav aria-label="...">
            <ul class="pagination text-smallest mb-0 pb-0">
              <li class="page-item" :class="{ disabled: pagination.currentPage === 1 }">
                <button class="page-link" @click="setPage(1)">First</button>
              </li>
              <li
                v-for="page in paginationPages"
                :key="page"
                class="page-item"
                :class="{
                  disabled: page === '...',
                  active: page === pagination.currentPage
                }"
              >
                <button class="page-link" @click="setPage(page)">
                  {{ page }}
                </button>
              </li>
              <li class="page-item" :class="{ disabled: pagination.currentPage === pagination.lastPage }">
                <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <table class="table table-sm table-bordered text-center mb-0">
        <thead>
        <tr>
          <th width="1" class="align-middle font-weight-bold text-uppercase" style="color: black">#</th>
          <th class="align-middle font-weight-bold text-uppercase" style="color:black; width: 85px">Code</th>
          <th class="align-middle font-weight-bold text-uppercase" style="color:black; width: 85px">Type of Finding</th>
          <th class="align-middle font-weight-bold text-uppercase" style="color:black; width: 85px">Severity Level</th>
          <th class="align-middle font-weight-bold text-uppercase" style="color:black;">List Of Findings</th>
          <th class="align-middle font-weight-bold text-uppercase" style="color:black; width: 85px">Status</th>
          <th class="align-middle font-weight-bold text-uppercase" style="color:black; width: 60px">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(nonConformity, index) in rsNonConformities"
          :key="nonConformity.id"
          :class="{ 'e-bg-blue-light-8': nonConformity.id === nonConformityId }"
        >
          <td class="align-middle text-center" style="color: black">{{ index + pagination.from }}</td>
          <td class="align-middle text-center" style="color: black">{{ nonConformity.rsn_question?.code }}</td>
          <td class="align-middle text-center text-uppercase font-weight-bold" style="color: black">{{nonConformity.type_of_finding}}</td>
          <td class="align-middle text-center text-uppercase font-weight-bold" style="color: black;"
              :style="{
                backgroundColor: nonConformity.severity_level === 'Low' ? '#f8e71b' :
                                 nonConformity.severity_level === 'Medium' ? '#f4a623' :
                                 nonConformity.severity_level === 'High' ? '#c4130d' :
                                 '#fff'
          }">
            {{nonConformity.severity_level}}
          </td>
          <td class="align-middle text-center" v-html="nonConformity.rsn_question?.main_question" style="color: black"></td>
          <td class="align-middle text-uppercase font-weight-bold" style="color: white"
              :style="{
                backgroundColor: nonConformity.report_status_id === 1 ? '#42b983' :
                                 nonConformity.report_status_id === 2 ? '#042453' :
                                 nonConformity.report_status_id === 3 ? '#4c4c4c' :
                                 nonConformity.report_status_id === 4 ? '#eda119' :
                                 '#056cb4'
          }">
            {{
              nonConformity.report_status_id
                ? reportStatusInitial.find(stat => stat.id === nonConformity.report_status_id)?.name
                : "NEW"
            }}
          </td>
          <td>
            <div class="dropdown dropright my-0">
              <button
                id="actionDropdown"
                aria-expanded="false"
                aria-haspopup="true"
                class="btn btn-sm btn-secondary force-white-all"
                data-toggle="dropdown"
              >
                <font-awesome-icon icon="cogs" />
              </button>
              <div aria-labelledby="actionDropdown" class="dropdown-menu py-0">
                <button class="dropdown-item text-secondary font-weight-bolder"
                        @click="viewNonConformity(nonConformity)"
                        v-if="isAllowed('rightship.main.risq-findings.index.view') || isElite()"
                >
                  <font-awesome-icon icon="eye" /> View
                </button>
                <button class="dropdown-item text-secondary font-weight-bolder text-danger"
                        @click="confirmDeleteNonConformity(nonConformity)"
                        v-if="isAllowed('rightship.main.risq-findings.index.delete') || isElite()"
                >
                  <font-awesome-icon icon="trash" class="force-danger-all" /> Delete
                </button>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="rsNonConformities.length === 0">
          <td class="text-center font-weight-bold text-muted" colspan="5">
            NO DATA SAVED
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="card p-3 shadow-sm mt-3" v-if="nonConformityId">
      <div class="row justify-content-between">
        <div class="col-auto">
          <h5 class="e-text-red">Detail of Findings</h5>
        </div>
      </div>

      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a
            v-if="isAllowed('rightship.main.risq-findings.main.detail.menu') || isElite()"
            class="nav-item nav-link"
            id="nav-Detail-tab"
            data-toggle="tab"
            role="tab"
            :class="{ active: $route.name === 'NonConformityDetail' }"
            @click="setTab('NonConformityDetail')"
          >Detail</a>

          <a
            v-if="isAllowed('rightship.main.risq-findings.main.corrective-action.menu') || isElite()"
            class="nav-item nav-link"
            id="nav-CorrectiveAction-tab"
            data-toggle="tab"
            role="tab"
            :class="{ active: $route.name === 'NonConformityCorrectiveAction' }"
            @click="setTab('NonConformityCorrectiveAction')"
          >Corrective Action</a>

          <a
            v-if="isAllowed('rightship.main.risq-findings.main.preventative-measures.menu') || isElite()"
            class="nav-item nav-link"
            id="nav-PreventativeMeasures-tab"
            data-toggle="tab"
            role="tab"
            :class="{ active: $route.name === 'NonConformityPreventativeMeasure' }"
            @click="setTab('NonConformityPreventativeMeasure')"
          >Preventative Measures</a>

          <router-link
            v-if="isAllowed('rightship.main.risq-findings.main.company-instruction.menu') || isElite() || isOwnVessel('rsReport')"
            class="nav-item nav-link"
            id="nav-CompanyInstruction-tab"
            data-toggle="tab"
            :class="{ active: $route.name === 'NonConformityCompanyInstruction' }"
            :to="{ name: 'NonConformityCompanyInstruction', query: { non_conformity_id: nonConformityId } }"
            @click="setTab('NonConformityCompanyInstruction')"
          >Company Instruction</router-link>
        </div>
      </nav>

      <div class="tab-content pt-2" id="nav-tabContent">
        <router-view></router-view>
      </div>
    </div>

    <NonConformityAdd @loadPage="setPage" />
  </div>
</template>

<script>
import NonConformityAdd from "@/components/modules/rightship/non-conformity/NonConformityAdd.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { PaginationMixin } from "@/mixins/PaginationMixin";
import RsNonConformityMixin from "@/mixins/RsNonConformityMixin";
import { AlertService } from "@/services/AlertService";
import {permissionMixin} from "@/mixins/permissionMixins";

export default {
  name: "RsNonConformity",
  components: { NonConformityAdd },
  mixins: [PaginationMixin, RsNonConformityMixin, permissionMixin],
  data() {
    return {
      defIdFromRouteQuery: null,
      toEdit: false,
      filters: {},
      selectedRevisionId: null,
      reportStatusInitial: [
        { id: 1, name: "In Progress" },
        { id: 2, name: "Ready to Close" },
        { id: 3, name: "Closed" },
        { id: 4, name: "Withdraw" },
      ],
    };
  },
  computed: {
    ...mapGetters(["rsNonConformities", "pagination", 'rsReport']),
    ...mapState("RevisionModule", ["revisions"]),
    selectedRevision() {
      return this.revisions.find(rev => rev.id === this.selectedRevisionId);
    }
  },
  methods: {
    ...mapActions(["getRsncQuestionKeys", "getRsNonConformities", "deleteNonConformity"]),
    ...mapActions("RevisionModule", ["fetchRevisions"]),

    async checkRouteDeficienyExists() {
      if (this.$route.query.def_id) {
        this.defIdFromRouteQuery = this.$route.query.def_id;
        if (this?.rsNonConformities && Array.isArray(this?.rsNonConformities)) {
          const matchingNonConformity = this?.rsNonConformities.find(
            (nonConformity) => {
              return nonConformity.id == this.defIdFromRouteQuery;
            }
          );

          if (matchingNonConformity) {
            await this.viewNonConformity(matchingNonConformity);
            await this.setTab('NonConformityCompanyInstruction');
          }
        }
      }
    },

    setTab(route) {
      if (this.$route.query.def_id) {
        if(route === 'NonConformityCompanyInstruction'){
          this.$router.push({ name: 'NonConformityCompanyInstruction', query: { non_conformity_id: this.defIdFromRouteQuery } });
        }
      }
      else{
        this.$router.push({ name: route, query: { tz: Date.now() } });
      }
    },
    async setPage(page = null) {
      this.filters.page = page ?? 1;
      await this.getRsNonConformities(this.filters);
    },
    async confirmDeleteNonConformity(nonConformity) {
      if (
        await AlertService.confirmDeleteAlert(
          "Delete RISQ-Finding",
          "Do you want to delete this RISQ-Finding?",
          "Yes Proceed"
        )
      ) {
        const response = await this.deleteNonConformity(nonConformity);
        if (response) {
          AlertService.successAlert("RISQ-Finding Deleted Successfully", "Delete RISQ-Finding");
          this.setPage(this.pagination.currentPage);
        }
      }
    },
    onRevisionChange() {
      this.filters.revision_number_id = this.selectedRevisionId;
      this.setPage(1);
    },
  },
  async created() {
    this.filters.rs_id = this.$route.params.id;
    this.getRsncQuestionKeys();
    await this.fetchRevisions();
    if (this.revisions.length > 0) {
      const sorted = [...this.revisions].sort((a, b) =>
        parseFloat(b.revision_number) - parseFloat(a.revision_number)
      );
      const latest = sorted[0];
      this.selectedRevisionId = latest.id;
      this.filters.revision_number_id = latest.id;
    }

    await this.setPage(this.filters);
    await this.checkRouteDeficienyExists();

  },
  destroyed() {
    localStorage.removeItem("currentDeficiency");
  },
};
</script>

<style scoped>
.nav > .nav-link {
  padding: 8px 16px;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  color: #435464;
  margin-bottom: -1px;
}
.nav > .active,
.nav > .nav-link:hover {
  border-bottom: 2px solid #d3313c;
  color: #d3313c;
}
.nav-tabs {
  border-bottom: 2px solid #dee2e6;
}
table td {
  padding-bottom: 0.25rem;
}
</style>
